const endpoint = 'checkout/content';

export default ['api', function (api) {
    return {
        getContent: slug => {
            return api.get(`${endpoint}/${slug}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/content.service.js